import {
  DEPLOY_LOG_LIST,
  DEPLOY_LOG_GET,
  DEPLOY_CURR_LOG,
} from "constants/ActionTypes"

const INIT_STATE = {
  db_deploy_logs: [],
  db_deploy_log: null,
  db_curr_log: null,
}

export default (state = INIT_STATE, action) => {
  switch(action.type) {
    case DEPLOY_LOG_LIST: {
      return {
        ...state,
        db_deploy_logs: action.payload
      }
    }
    case DEPLOY_LOG_GET: {
      return {
        ...state,
        db_deploy_log: action.payload
      }
    }
    case DEPLOY_CURR_LOG: {
      return {
        ...state,
        db_curr_log: action.payload
      }
    }

    

    default:
      return state;
  }
}